module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d12a999338123fc4e1e65502f703efbe.png";